// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i-MQ","left":"styles_left__3ISHF","desktopActions":"styles_desktopActions__2YrZG","title":"styles_title__xinfz"};